"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n\n  cursor: pointer;\n  background-color: var(--color-grey-dark-1);\n  opacity: 0;\n  transition: opacity 0.3s;\n\n  &:hover {\n    opacity: 0.5;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  z-index: 2;\n\n  & [data-meta='variable-text-editor'] {\n    min-width: 18.75em;\n  }\n\n  transition: background-color 0.3s;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.75);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var image_option_view_styles_1 = require("../image-option-view/image-option-view.styles");

var styled_components_1 = __importDefault(require("styled-components"));

var scenario_node_view_styles_1 = require("../scenario-node-view/scenario-node-view.styles");

exports.StyledEditableImageOptionDiv = styled_components_1.default(image_option_view_styles_1.StyledImageOptionDiv)(_templateObject());
exports.StyledEditableImageOptionDiv.defaultProps = {
  theme: scenario_node_view_styles_1.DEFAULT_SCENARIO_NODE_THEME
};
exports.StyledEditableImageNameDiv = styled_components_1.default(image_option_view_styles_1.StyledImageNameDiv)(_templateObject2());
exports.StyleOverlayDiv = styled_components_1.default.div(_templateObject3());